<template>
  <select-remote-multi
      :title="info.title"
      :widget="selectRemoteWidget"
      v-model="value"
  />
</template>
<script setup lang="ts">
import {defineProps, ref, watch} from "vue";
import {SelectRemoteFieldType} from "@/components/business/crud/interface/FieldType";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {SelectRemoteSearch} from "@/components/business/crud/interface/SearchType";
import _ from "lodash";
import SelectRemoteMulti from "@/components/business/crud/common/SelectRemoteMulti.vue";

const props = defineProps<{
  propName: string;
  widget: SelectRemoteSearch;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const selectRemoteWidget: SelectRemoteFieldType = {
  name: "selectRemote",
  path: props.widget.path,
  labelFieldName: props.widget.labelFieldName,
  valueFieldName: props.widget.valueFieldName,
  multi: true,
}

const value = ref<{ value: string; label: string }[]>([]);

watch(() => data.value[props.propName], () => {
  if (data.value[props.propName]instanceof Array) {
    value.value = data.value[props.propName]
  } else {
    value.value = [];
  }
}, {immediate: true, deep: true})

watch(value, () => {
  if (value.value.length > 0) {
    _.set(data.value, [props.propName], value.value);
  } else {
    delete data.value[props.propName];
  }
}, {immediate: true, deep: true})


</script>

<style lang="scss" scoped></style>
